<template>
  <button @click.stop="$emit('click')"
 >{{text?text:'儲存'}}</button>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
button {
  height: 35px;
  color: #FFFFFF;
  width: 100px;
  letter-spacing: 0.1em;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FF8B8B;
  border-radius: 20px;
}
}
</style>
